import { keepPreviousData, queryOptions } from '@tanstack/react-query';

import { api } from '#client';
import { parseSchema } from '#client/validation';

import { RiskFilters } from './risks.types';
import { Stats } from './stats.types';

const getStats = async (filters: RiskFilters): Promise<Stats> =>
	api
		.get('/risks/riskdashboardmetrics', { params: filters })
		.then(parseSchema(Stats));

export const statsQueries = {
	all: ['riskStats'],
	stats: (filters: RiskFilters) =>
		queryOptions({
			queryKey: [...statsQueries.all, filters],
			queryFn: () => getStats(filters),
			placeholderData: keepPreviousData,
		}),
};
